const STORE_ID = "DASHBOARD_PRODUCAO";

const TYPES = {
    SET_FILTROS: "SET_FILTROS",
    SET_BIG_NUMBERS: "SET_BIG_NUMBERS",
    SET_TABELA_PRODUCAO: "SET_TABELA_PRODUCAO",
    SET_DASH_PRODUCAO: "SET_DASH_PRODUCAO",
    SET_INSTITUICOES: "SET_INSTITUICOES",
    SET_LOJAS: "SET_LOJAS",
    SET_TABELA_PRODUTO: "SET_TABELA_PRODUTO",
    SET_TABELA_CANAL: "SET_TABELA_CANAL",
    SET_CANAIS: "SET_CANAIS",
    SET_MODAL_LOJAS: "SET_MODAL_LOJAS",
    SET_GET_ALL_LOJAS: "SET_GET_ALL_LOJAS",
    SET_MODAL_CONSULTORES: "SET_MODAL_CONSULTORES",
    SET_GET_ALL_CONSULTORES: "SET_GET_ALL_CONSULTORES",
    SET_PRODUTOS_RIBER: "SET_PRODUTOS_RIBER",
    SET_TIPOS_OPERACAO: "SET_TIPOS_OPERACAO",
    SET_PARCERIAS: "SET_PARCERIAS",
    SET_CONVENIOS: "SET_CONVENIOS",
    SET_GRUPOS: "SET_ACTIVE_TAB",
    SET_HIERARQUIAS: "SET_HIERARQUIAS",
    SET_CONSULTORES: "SET_CONSULTORES",
    SET_FILTROS_SELECIONADOS: "SET_FILTROS_SELECIONADOS",
    CLEAN_FILTROS: "CLEAN_FILTROS",
    CLEAN_REGISTER: "CLEAN_REGISTER",
    SET_LOADING_LOJAS: "SET_LOADING_LOJAS",
    SET_LOADING_CONSULTORES: "SET_LOADING_CONSULTORES",
    SET_FILTROS_APLICADOS: "SET_FILTROS_APLICADOS",
    CLEAN_FILTROS_APLICADOS: "CLEAN_FILTROS_APLICADOS"
}

export { STORE_ID, TYPES }